// extracted by mini-css-extract-plugin
module.exports = {"tableFooter":"TableFooter_tableFooter__qoVr5","features":"TableFooter_features__0232K"};